var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13477 7.83496V17.1547L8.67967 12.476L4.13477 7.83496Z",
    fill: "#2E1834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8641 7.83496V17.1547L15.3418 12.4949L19.8641 7.83496Z",
    fill: "#2E1834"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47852 7.41211H19.4905L13.5905 13.5555C13.1706 13.9927 12.5907 14.2398 11.9845 14.2398C11.3784 14.2398 10.7984 13.9927 10.3785 13.5555L4.47852 7.41211Z",
    fill: "#2E1834"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9309 13.8818C13.4247 14.4089 12.7153 14.7112 11.9845 14.7112C11.2538 14.7112 10.5443 14.409 10.0382 13.8819L9.03744 12.8398L4.47852 17.5867H19.4905L14.9316 12.8398L13.9309 13.8818Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.de1e2fa7e9292826327d457395cdd029.svg";
export { ForwardRef as ReactComponent };